// extracted by mini-css-extract-plugin
module.exports = {"table":"PlayerResultsStats_table_1ky6k"};